import { validator } from "@/utils/validator";

export const companySpecificBusinessClassificationSchema = validator.object().shape({
  companySpecificBusinessClassificationName: validator.string().trim().emptyToNull().label("業務区分（会社情報用）").required(),
});

export const masterDataCreateCompanySpecificIndustrySchema = validator.object().shape({
  companySpecificIndustry: validator.string().trim().emptyToNull().label("特定産業分野（企業）").required(),
  sectorCouncil: validator.string().trim().emptyToNull().max(255).label("加入している分野別協議会").nullable(),
  companySpecificBusinessClassifications: validator
    .array()
    .of(companySpecificBusinessClassificationSchema)
    .label("companySpecificBusinessClassifications")
    .required(),
});

export const masterDataUpdateCompanySpecificIndustrySchema = validator.object().shape({
  companySpecificIndustry: validator.string().trim().emptyToNull().label("特定産業分野（企業）").required(),
  sectorCouncil: validator.string().trim().emptyToNull().max(255).label("加入している分野別協議会").nullable(),
});

export const companyMainSkillSchema = validator.object().shape({
  mainSkillName: validator.string().trim().emptyToNull().label("主たる技能").required(),
  examName1Year: validator.string().trim().emptyToNull().label("試験名（1年経過時まで）").required(),
  examGrade1Year: validator.number().emptyToNull().label("級（1年経過時まで）").nullable(),
  examNameFinal: validator.string().trim().emptyToNull().label("試験名（育成就労終了まで）").required(),
  examGradeFinal: validator.number().emptyToNull().label("級（育成就労終了まで）").nullable(),
  employerChangeRestrictionPeriod: validator.number().emptyToNull().label("育成就労実施者の変更を制限する期間(分野単位)").nullable(),
});
